import React from "react";
import "./ProductSection.css";
import researchImg from "../assets/research.jpg";
import manufacturingImg from "../assets/manufacturing.jpeg";
import qualityControlImg from "../assets/quality-control.png";
import secureDeliveryImg from "../assets/secure-delivery.png";

const steps = [
  {
    id: 1,
    title: "Research",
    description: "Scientific investigation to understand ingredients, nutrient interactions, and their roles in supporting human physiology.",
    image: researchImg,
  },
  {
    id: 2,
    title: "Manufacturing",
    description: "Careful formulation and production processes designed to preserve the quality, integrity, and functionality of natural ingredients.",
    image: manufacturingImg,
  },
  {
    id: 3,
    title: "Quality Control",
    description: "Rigorous testing and verification processes to ensure safety, consistency, and compliance with quality standards.",
    image: qualityControlImg,
  },
  {
    id: 4,
    title: "Secure Delivery",
    description: "Efficient distribution systems ensuring safe, reliable, and timely access to our products.",
    image: secureDeliveryImg,
  },
];

const ProductSection = () => {
  return (
    <section className="process-section">
      <h2 className="process-title">OUR END-TO-END PROCESS</h2>
      <div className="process-grid">
        {steps.map((step) => (
          <div className="process-card" key={step.id}>
            <div className="process-image">
              <img src={step.image} alt={step.title} />
            </div>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductSection;
